import { useContactForm } from '../../hooks/useContactForm';

const fields = [
  { name: 'name', label: 'Ad Soyad', type: 'text', maxLength: 120, autoComplete: 'name' },
  { name: 'email', label: 'E-posta', type: 'email', autoComplete: 'email' },
  { name: 'phone', label: 'Telefon', type: 'tel', maxLength: 40, autoComplete: 'tel' },
  { name: 'subject', label: 'Konu', type: 'text', maxLength: 200 },
  { name: 'message', label: 'Mesaj', multiline: true, maxLength: 2000 },
];

const ContactField = ({ field, value, onChange, disabled }) => {
  const { name, label, multiline, ...attributes } = field;
  const Field = multiline ? 'textarea' : 'input';
  return (
    <Field
      {...attributes} name={name} aria-label={label} placeholder={label}
      data-testid={`contact-${name}-input`} value={value} onChange={onChange}
      disabled={disabled} rows={multiline ? 5 : undefined}
      className="w-full bg-input border border-border rounded-lg px-5 py-4 text-[14.5px] text-white placeholder:text-muted-foreground focus:border-accent focus:bg-secondary transition-colors resize-none disabled:opacity-60"
    />
  );
};

export const ContactForm = () => {
  const { form, submitting, handleChange, handleSubmit } = useContactForm();
  return (
    <form data-testid="contact-form" onSubmit={handleSubmit} aria-busy={submitting} className="bg-card border border-border rounded-2xl p-7 sm:p-10 space-y-5">
      {fields.map((field) => <ContactField key={field.name} field={field} value={form[field.name]} onChange={handleChange} disabled={submitting} />)}
      <button data-testid="contact-submit-button" type="submit" disabled={submitting} className="w-full py-4 rounded-full bg-gradient-to-b from-primary to-primary-hover text-primary-foreground text-[12px] font-semibold tracking-[0.22em] hover:from-primary-hover hover:to-primary-hover transition-colors duration-300 shadow-lg shadow-primary/20 disabled:opacity-60">
        {submitting ? 'GONDERILIYOR...' : 'GONDER'}
      </button>
    </form>
  );
};